// import styles from "./BallroomGrid.module.css";
// import BallroomCard from "./BallroomCard";

// export default function BallroomGrid({
//   hotel,
//   ballrooms,
// }) {
//   if (!ballrooms || ballrooms.length === 0) {
//     return (
//       <div className={styles.empty}>
//         No ballrooms available for this hotel.
//       </div>
//     );
//   }

//   return (
//     <section className={styles.wrapper}>
//       <div className={styles.header}>
//         <div>
//           <h2>{hotel.name}</h2>
//           <p>
//             {ballrooms.length} Ballroom
//             {ballrooms.length > 1 ? "s" : ""} Available
//           </p>
//         </div>
//       </div>

//       <div className={styles.grid}>
//         {ballrooms.map((ballroom) => (
//           <BallroomCard
//             key={ballroom.id}
//             hotel={hotel}
//             ballroom={ballroom}
//           />
//         ))}
//       </div>
//     </section>
//   );
// }

// import styles from "./BallroomGrid.module.css";
// import BallroomCard from "./BallroomCard";

// export default function BallroomGrid({
//   hotel,
//   ballrooms,
// }) {
//   if (!ballrooms || ballrooms.length === 0) {
//     return (
//       <div className={styles.empty}>
//         No ballrooms available for this hotel.
//       </div>
//     );
//   }

//   return (
//     <section className={styles.wrapper}>
//       <div className={styles.header}>
//         <div>
//           <h2>{hotel.name}</h2>
//           <p>
//             {ballrooms.length} Ballroom
//             {ballrooms.length > 1 ? "s" : ""} Available
//           </p>
//         </div>
//       </div>

//       <div className={styles.grid}>
//         {ballrooms.map((ballroom) => (
//           <BallroomCard
//             key={ballroom.id}
//             hotel={hotel}
//             ballroom={ballroom}
//           />
//         ))}
//       </div>
//     </section>
//   );
// }


import styles from "./BallroomGrid.module.css";
import BallroomCard from "./BallroomCard";

export default function BallroomGrid({
  hotel,
  ballrooms,
  variant = "hotel",
  currentBallroom,
}) {
  if (!ballrooms || ballrooms.length === 0) {
    return null;
  }

  const displayBallrooms =
    variant === "other"
      ? ballrooms.filter(
          (ballroom) => ballroom.slug !== currentBallroom?.slug
        )
      : ballrooms;

  if (displayBallrooms.length === 0) {
    return null;
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.header}>
        {/* <div>
          <h2>
            {variant === "other"
              ? `More Venues at ${hotel.name}`
              : hotel.name}
          </h2>

          <p>
            {variant === "other"
              ? "Explore other event spaces available at this hotel."
              : `${displayBallrooms.length} Ballroom${
                  displayBallrooms.length > 1 ? "s" : ""
                } Available`}
          </p>
        </div> */}
        <div>
  <h2>
    {variant === "other"
      ? "Other Ballrooms"
      : hotel.name}
  </h2>

  {variant !== "other" && (
    <p>
      {displayBallrooms.length} Ballroom
      {displayBallrooms.length > 1 ? "s" : ""} Available
    </p>
  )}
</div>
      </div>

      <div className={styles.grid}>
        {displayBallrooms.map((ballroom) => (
          <BallroomCard
            key={ballroom.id}
            hotel={hotel}
            ballroom={ballroom}
          />
        ))}
      </div>
    </section>
  );
}